import React, { useState } from "react";
import { warningMessage } from "../../../../../../../utils/toastify-message/ToastifyMessage";
const { forwardRef, useRef, useImperativeHandle } = React;

const AddProductModal = forwardRef(({ handleProduct }, ref) => {
  const [showModal, setShowModal] = useState(false);

  const [data, setData] = useState(null);
  const [selectable, setSelectable] = useState(false);

  const [variationSku, setVariationSku] = useState(null);
  const [count, setCount] = useState(1);

  useImperativeHandle(ref, () => ({
    showModal(data) {
      setShowModal(!showModal);
      setData(data || null);
    },
  }));

  const formHandler = () => {
    if (data?.option?.name) {
      if (variationSku) {
        handleProduct({
          product: data,
          productSku: data?.sku,
          productVarSku: variationSku,
          count: count > 0 ? count : 1,
          selectable: selectable,
        });
        setCount(1);
        setSelectable(false);
        setVariationSku(null);
        setShowModal(false);
      } else {
        warningMessage(`باید ${data?.option?.name} کالا را انتخاب کنید.`);
      }
    } else {
      handleProduct({
        product: data,
        productSku: data?.sku,
        count: count > 0 ? count : 1,
      });
      setCount(1);
      setVariationSku(null);
      setShowModal(false);
    }
  };

  return (
    <>
      <div
        className={`fixed top-0 right-0 w-full h-full bg-black/40 transition-all z-[800]  ${
          !showModal && "hidden"
        }`}
        onClick={() => setShowModal(false)}
      ></div>
      <div
        className={`w-[320px] sm:w-[500px] py-4 pt-40 sm:pt-14 max-h-[360px] overflow-y-scroll mt-4 flex items-center justify-center bg-white rounded-lg shadow z-[810] rounded-3xl p-4 transition-all fixed top-0 right-[50%] mr-[-160px] sm:mr-[-250px] opacity-0 invisible ${
          showModal && "!mt-20 !opacity-100 !visible"
        }`}
      >
        <div>
          <button
            onClick={() => setShowModal(false)}
            type="button"
            className="absolute top-3 end-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
            data-modal-hide="popup-modal"
          >
            <svg
              className="w-3 h-3"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 14 14"
            >
              <path
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
              />
            </svg>
            <span className="sr-only">بستن مدال</span>
          </button>
          <div className="p-4 md:p-5 text-center">
            <svg
              className="mx-auto mb-6 text-gray-500 w-12 h-12 dark:text-gray-200"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 20 20"
            >
              <path
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M10 11V6m0 8h.01M19 10a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
              />
            </svg>
            <h3 className="mb-2 text-lg font-normal text-gray-500 dark:text-gray-400">
              آیا مطمئن هستید که می خواهید کالا {data?.name} را به لیست اضافه
              کنید ؟{" "}
            </h3>
            <div className="w-full flex items-center gap-2 justify-center mb-6">
              {data?.option ? (
                <>
                  <h4>{data?.option?.name}</h4>
                  <div>
                    <select
                      value={variationSku}
                      onChange={(e) => setVariationSku(e.target.value)}
                      className={`bg-white/50 min-w-24 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-gray-800 dark:focus:ring-blue-500 dark:focus:border-blue-500`}
                    >
                      <option value={""}>انتخاب {data?.option?.name}</option>
                      {data?.option?.variations.map((item) => {
                        return <option value={item?.sku}>{item.value}</option>;
                      })}
                    </select>
                  </div>
                </>
              ) : null}
            </div>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-2">
              <div className="w-40 flex items-center gap-2 justify-center mb-6">
                <h4>تعداد</h4>
                <div>
                  <input
                    value={count}
                    min={1}
                    onChange={(e) => setCount(e.target.value)}
                    onKeyPress={(event) => {
                      if (!/[0-9]/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  />
                </div>
              </div>
            </div>
            {data?.option ? (
              <div className="my-4">
                <label class="inline-flex items-center cursor-pointer">
                  <span class="me-3 text-sm font-medium text-gray-900 dark:text-gray-300">
                    ویژگی قابل ویرایش
                  </span>
                  <input
                    checked={selectable}
                    onClick={() => setSelectable(!selectable)}
                    type="checkbox"
                    class="sr-only peer"
                  />
                  <div class="relative w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
                </label>
              </div>
            ) : null}
            <div className="flex items-center justify-center gap-2">
              <button
                onClick={() => setShowModal(false)}
                data-modal-hide="popup-modal"
                type="button"
                className="py-2.5 px-5 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-lg border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:ring-gray-100 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700"
              >
                خیر
              </button>
              <button
                onClick={formHandler}
                data-modal-hide="popup-modal"
                type="button"
                className="text-white bg-green-600 hover:bg-green-800 focus:ring-4 focus:outline-none focus:ring-green-300 dark:focus:ring-green-800 font-medium rounded-lg text-sm inline-flex items-center px-10 py-2.5 text-center"
              >
                بله
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
});
export default AddProductModal;
